export const alertError = a => {
  alert(Object.values(a.body).map(b => b.join('\n')).join("\n"));
}
export const y = a => (b => b(b))(b => a(c => b(b)(c)))
